import './styles.scss';

const SHOW_HIDE_THRESHOLD = 600;
const TOGGLE_CLASSES = ['opacity-0', 'pointer-events-none'];

const backToTopElement = document.getElementById('back-to-top');
const backToTopLink = backToTopElement.querySelector('a');

function toggleBackToTop() {
  const showIt = userScrolledPassedTheThreshold();
  TOGGLE_CLASSES.forEach((toggleClass) => {
    backToTopElement.classList.toggle(toggleClass, !showIt);
  });
}

function userScrolledPassedTheThreshold() {
  return (
    document.body.scrollTop > SHOW_HIDE_THRESHOLD ||
    document.documentElement.scrollTop > SHOW_HIDE_THRESHOLD
  );
}

export default function initBackToTop() {
  window.addEventListener('scroll', () => toggleBackToTop());

  ['click', 'keydown'].forEach((eventType) => [
    backToTopLink.addEventListener(eventType, (event) => {
      if (event.type === 'click' || event.key === 'Enter') {
        event.preventDefault();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        backToTopLink.blur();

        const focusSelector =
          event.type === 'click'
            ? '#skip-to a:last-child'
            : '#skip-to a:first-child';
        const focusElement = document.querySelector(focusSelector);
        const focusBlur = event.type === 'click' ? true : false;

        setTimeout(() => {
          focusElement.focus();
          if (focusBlur) {
            focusElement.blur();
          }
        }, 625);
      }
    }),
  ]);
}
